<template>
  <div class="main">
    <div v-for="(item, index) in infoList" :key="index" :class="item.width ? 'compay-info compay' : 'compay'">
      <span class="title">{{ item.title }}</span>
      <span class="info">{{ item.prop }}</span>
    </div>
  </div>
</template>

<script>
import { infoList } from '@account/static/data.js';
export default {
  props: {
    title: {
      type: String,
    },
  },
  data() {
    return {
      // 内容
      infoList: [],
    };
  },
  mounted() {
    this.infoList = infoList.get(this.title);
  },
};
</script>

<style lang="less" scoped>
.main {
  padding: 30px 40px 0 33px;
}
.compay {
  display: flex;
  margin: 0 0 30px 0;
}
.compay-info {
  display: inline-block;
  width: 50%;
}
.title {
  display: inline-block;
  width: 100px;
  flex-shrink: 0;
  padding-right: 40px;
  white-space: nowrap;
}
.info {
  line-height: 20px;
}
</style>
